import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=aa87137a&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=aa87137a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa87137a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa87137a')) {
      api.createRecord('aa87137a', component.options)
    } else {
      api.reload('aa87137a', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=aa87137a&scoped=true&", function () {
      api.rerender('aa87137a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8v8mtGChIa9zX/JS/comp/DateRangeExt.vue"
export default component.exports